import { clone } from 'ramda'
import actions from './actions'
import getters from './getters'
import * as types from './types'

const state = {
  selectedTab: 'TRANSIT',
  matchingData: [],
  actions: {
    markedAsUnmatched: false,
    markedAsResolved: false,
    id: ''
  },
  isLoading: false,
  filters: {
    status: 'Pending',
    currency: ''
  },
  pagination: {
    page: 1,
    itemsPerPage: 20
  },
  totalItems: 0,
  timeline: {
    open: false,
    id: '',
    comments: []
  },
  selectedToSend: { isEmpty: true },
  settle: {
    paymentInfo: [],
    forwardPayments: [],
    pagination: {
      limit: 100,
      page: 0,
      total: NaN
    }
  },
  etcId: '',
  amountDiscount: 0,
  selectedSettlement: {},
  selectedToSettle: [],
  selectedToSettleEtp: [],
  statementToDelete: '',
  sendPaymentResult: {
    forwardSuccess: false,
    actionFailed: false
  },
  showSuccessMessage: false,
  beneficiaryInfo: [],
  searchResultsList: [],
  searchResultsEtp: [],
  settleAsDepositDialog: {
    isOpen: false,
    item: {}
  },
  newSettleAmountValue: [],
  settleDepositDialogConfirmation: {
    isOpen: false,
    info: null
  }
}

const mutations = {
  [types.SET_SELECTED_TAB](state, value) {
    state.selectedTab = value
  },
  [types.SET_INCOMING_PAYMENTS](state, value) {
    state.matchingData = value
  },
  [types.SET_IS_LOADING](state, value) {
    state.isLoading = value
  },
  [types.SET_FILTERS](state, { key, value }) {
    if (key) {
      state.filters = {
        ...state.filters,
        [key]: value
      }
    } else {
      state.filters = value
    }
  },
  [types.SET_TOTAL_ITEMS](state, value) {
    state.totalItems = value
  },
  [types.SET_MATCHING_ACTION](state, { key, value, id }) {
    state.actions = {
      ...state.actions,
      id,
      [key]: value
    }
  },
  [types.SET_DEFAULT_VALUES](state) {
    state.matchingData = []
    state.totalItems = 0
  },
  [types.SET_TIMELINE_VALUE](state, value) {
    state.timeline = {
      open: value.open,
      id: value.id,
      comments: value.comments
    }
  },
  [types.SET_PAGINATION](state, value) {
    state.pagination = value
  },
  [types.SET_SELECTED_TO_SEND](state, value) {
    state.selectedToSend = value
  },
  [types.SET_SELECTED_TO_SETTLE](state, value) {
    state.selectedToSettle = value
  },
  [types.ADD_SELECTED_TO_SETTLE_ETP](state, newSelectedToSettleEtp) {
    state.selectedToSettleEtp = [
      ...state.selectedToSettleEtp,
      newSelectedToSettleEtp
    ]
  },
  [types.REMOVE_SELECTED_TO_SETTLE_ETP](state, etpToRemoveId) {
    const pos = state.selectedToSettleEtp.findIndex(
      ({ id }) => id === etpToRemoveId
    )

    if (pos !== -1) {
      const clonedSelectedToSettleEtp = clone(state.selectedToSettleEtp)
      clonedSelectedToSettleEtp.splice(pos, 1)
      state.selectedToSettleEtp = clonedSelectedToSettleEtp
    }
  },
  [types.SET_SELECTED_TO_SETTLE_ETP](state, value) {
    state.selectedToSettleEtp = value
  },
  [types.SET_SELECTED_SETTLEMENT](state, value) {
    state.selectedSettlement = value
  },
  [types.SET_SETTLE_PAYMENT_INFO](state, value) {
    state.settle = {
      ...state.settle,
      paymentInfo: value.paymentInfo,
      forwardPayments: value.forwardPayments
    }
  },
  [types.SET_AMOUNT_TO_DISCOUNT](state, value) {
    state.amountDiscount = value
  },
  [types.SET_STATEMENT_TO_DELETE](state, value) {
    state.statementToDelete = value
  },
  [types.SET_PAYMENT_RESULT](state, { key, value }) {
    state.sendPaymentResult = {
      ...state.sendPaymentResult,
      [key]: value
    }
  },
  [types.SET_SUCCESS_MESSAGE](state, value) {
    state.showSuccessMessage = value
  },
  [types.SET_BENEFICIARY_INFO](state, value) {
    state.beneficiaryInfo = value
  },
  [types.SET_RESULTS_LIST](state, value) {
    state.searchResultsList = value
  },
  [types.SET_SEARCH_RESULTS_ETP](state, newSearchResultsEtp) {
    state.searchResultsEtp = newSearchResultsEtp
  },
  [types.SET_SETTLE_PAGINATION_TOTAL](state, value) {
    state.settle = {
      ...state.settle,
      pagination: value
    }
  },
  [types.SET_SETTLE_AS_DEPOSIT_DIALOG](state, { isOpen, item = {} }) {
    state.settleAsDepositDialog = {
      isOpen,
      item
    }
  },
  [types.SET_NEW_SETTLE_AMOUNT_VALUE](state, value) {
    state.newSettleAmountValue = [...state.newSettleAmountValue, value]
  },
  [types.RESET_SETTLE_VALUES](state) {
    state.newSettleAmountValue = []
    state.selectedToSettle = []
    state.searchResultsList = []
    state.searchResultsEtp = []
    state.selectedToSettleEtp = []
  },
  [types.SET_SETTLE_DEPOSIT_DIALOG_CONFIRMATION](
    state,
    { isOpen, info = null }
  ) {
    state.settleDepositDialogConfirmation = {
      isOpen,
      info
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
